export default __webpack_public_path__ + "static/media/blend-table-overlay.19fb1b2f.svg";